
import React from 'react';
import { Formik, Form } from 'formik';
import { AddContainer, Component4, Texts, InputTextComponent, LabelWithTooltip } from './Style';
import { getUserFromToken } from 'src/DecodeToken';
import * as Yup from 'yup';


const validationSchema = Yup.object().shape({
    title: Yup.string().required('Clinic Title is required'),
    tagLine: Yup.string().required('Tag Line is required'),
    clinicRegistrationInfo: Yup.string().required('Clinic Registration Info is required'),
    address: Yup.string().required('Address is required'),
    direction: Yup.string().required('Direction is required'),
    description: Yup.string().required('Description is required'),
    country: Yup.string(),
    state: Yup.string(),
    city: Yup.string(),
    area: Yup.string(),
    pincode: Yup.string().matches(/^[0-9]{6}$/, 'Must be exactly 6 digits'),
});

function ClinicInfo({ innerRef, data, setClinicProfileData }) {
    const userId = getUserFromToken();

    const initialValues = React.useMemo(() => ({
        // id: data?.id || '',
        title: data?.title || '',
        tagLine: data?.tagLine || '',
        clinicRegistrationInfo: data?.clinicRegistrationInfo || '',
        direction: data?.direction || '',
        description: data?.description || '',
        address: data?.address || '',
        pincode: data?.pincode || '',
        country: data?.country || '',
        state: data?.state || '',
        city: data?.city || '',
        area: data?.area || '',
    }), [JSON.stringify(data)]);

    const handleSubmit = (values) => {
        console.log('clinicInfo Submitted:', values);
        setClinicProfileData(prev => ({
            ...prev,
            clinicInfo: values
        }));
    };


    return (
        <Formik
            enableReinitialize
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
            innerRef={innerRef}
        >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue }) => (
                <Form>
                    <AddContainer>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Clinic Title" tooltip="Name of the clinic as you want patients to see." />
                            </Texts>
                            <InputTextComponent
                                name="title"
                                placeholder="Enter clinic title"
                                variant="outlined"
                                value={values.title}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.title && Boolean(errors.title)}
                                helperText={touched.title && errors.title}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Tag Line" tooltip="A short tagline or slogan for the clinic." />
                            </Texts>
                            <InputTextComponent
                                name="tagLine"
                                placeholder="Enter Tag Line"
                                variant="outlined"
                                value={values.tagLine}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.tagLine && Boolean(errors.tagLine)}
                                helperText={touched.tagLine && errors.tagLine}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Clinic Registration Info" tooltip="Official registration number or certificate info." />
                            </Texts>
                            <InputTextComponent
                                name="clinicRegistrationInfo"
                                placeholder="Enter Clinic Registration Info"
                                variant="outlined"
                                value={values.clinicRegistrationInfo}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.clinicRegistrationInfo && Boolean(errors.clinicRegistrationInfo)}
                                helperText={touched.clinicRegistrationInfo && errors.clinicRegistrationInfo}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Direction" tooltip="Landmarks or directions to help locate the clinic." />
                            </Texts>
                            <InputTextComponent
                                name="direction"
                                placeholder="Enter"
                                variant="outlined"
                                value={values.direction}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.direction && Boolean(errors.direction)}
                                helperText={touched.direction && errors.direction}

                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Description" tooltip="Brief about the clinic's specialties or offerings." />
                            </Texts>
                            <InputTextComponent
                                name="description"
                                placeholder="Enter"
                                variant="outlined"
                                multiline
                                rows={4}
                                value={values.description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.description && Boolean(errors.description)}
                                helperText={touched.description && errors.description}

                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        height: '120px',
                                        alignItems: 'flex-start',
                                    },
                                }}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Address" tooltip="Full address of the clinic for patients." />
                            </Texts>
                            <InputTextComponent
                                name="address"
                                placeholder="Enter"
                                variant="outlined"
                                multiline
                                rows={4}
                                value={values.address}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.address && Boolean(errors.address)}
                                helperText={touched.address && errors.address}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        borderRadius: '12px',
                                        height: '120px',
                                        alignItems: 'flex-start',
                                    },
                                }}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Country" tooltip="Enter the country where the clinic is located" />
                            </Texts>
                            <InputTextComponent
                                name="country"
                                placeholder="Enter Country"
                                variant="outlined"
                                value={values.country}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.country && Boolean(errors.country)}
                                helperText={touched.country && errors.country}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="State" tooltip="Specify the state for better geographic accuracy" />
                            </Texts>
                            <InputTextComponent
                                name="state"
                                placeholder="Enter State"
                                variant="outlined"
                                value={values.state}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.state && Boolean(errors.state)}
                                helperText={touched.state && errors.state}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="City" tooltip="Mention the city where your clinic is located" />
                            </Texts>
                            <InputTextComponent
                                name="city"
                                placeholder="Enter City"
                                variant="outlined"
                                value={values.city}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.city && Boolean(errors.city)}
                                helperText={touched.city && errors.city}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Area" tooltip="The local area or neighborhood of the clinic." />
                            </Texts>
                            <InputTextComponent
                                name="area"
                                placeholder="Enter Area"
                                variant="outlined"
                                value={values.area}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.area && Boolean(errors.area)}
                                helperText={touched.area && errors.area}
                            />
                        </Component4>
                        <Component4>
                            <Texts>
                                <LabelWithTooltip label="Pincode" tooltip="The 6-digit postal code of the clinic location." />
                            </Texts>
                            <InputTextComponent
                                name="pincode"
                                placeholder="Enter Pincode"
                                variant="outlined"
                                value={values.pincode}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={touched.pincode && Boolean(errors.pincode)}
                                helperText={touched.pincode && errors.pincode}
                            />
                        </Component4>

                    </AddContainer>
                </Form>
            )}
        </Formik>
    );
}

export default React.memo(ClinicInfo);
